import { atom } from 'recoil';

interface ImageDimensionsState {
    [key: string]: { height: number; width: number };
}

const defaultState: ImageDimensionsState = {};
export const imageDimensionsAtom = atom<ImageDimensionsState>({
    key: 'imageDimensionsAtom',
    default: defaultState,
});
